import { OrderRouteItem, ROUTE_ITEM_LABELS, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { NavItemType } from './types.ts';

export const craftsmanUIHeaderNavItems: Record<OrderRouteItem, NavItemType> = {
  'paired-cost': {
    label: 'Depreciated Cost',
    route: 'paired-cost',
    subnav: schPairedCostRouteItem.options.map((route) => ({
      label: ROUTE_ITEM_LABELS[route],
      route,
      parentRoute: 'paired-cost',
      ...(route === 'commentary'
        ? {
            items: [
              {
                label: 'Dep. Cost Adjustments',
                route: 'dep-cost',
                parentRoute: 'paired-cost',
                testID: 'dep-cost-nav-item',
              },
              {
                label: 'Site Extraction',
                route: 'site-extraction',
                parentRoute: 'paired-cost',
                testID: 'site-extraction-nav-item',
              },
              {
                label: 'Date of Sale Adjustments',
                route: 'date-of-sale-adjustments',
                parentRoute: 'paired-cost',
                testID: 'date-of-sale-adjustments-nav-item',
              },
              {
                label: 'Methodology',
                route: 'methodology',
                parentRoute: 'paired-cost',
                testID: 'methodology-nav-item',
              },
            ],
          }
        : {}),
    })),
  },
  studies: { label: 'Paired Sales', route: 'studies' },
};

export const APPRAISIFY_ONLY_ROUTES = [
  'details',
  'reconciliation',
  'appraisify-commentary',
  'features',
  'adjustments-grid',
];

export const SAAS_ONLY_ROUTES = ['craftsman-cost-approach', 'commentary', 'adjustments'];
